var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckBlackbg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 31,
    fill: "black",
    stroke: "black",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.1169 41.987L20.3247 33.2597C20.0909 33.026 19.987 32.7532 20.013 32.4416C20.039 32.1039 20.1688 31.8312 20.4026 31.6234C20.6623 31.3896 20.9481 31.2857 21.2597 31.3117C21.5714 31.3377 21.8442 31.4675 22.0779 31.7013L28.1948 38.5974L42.9221 23.8701C43.1558 23.6364 43.4286 23.5195 43.7403 23.5195C44.0779 23.5195 44.3636 23.6364 44.5974 23.8701C44.8312 24.1039 44.9481 24.3896 44.9481 24.7273C44.9481 25.039 44.8312 25.3117 44.5974 25.5455L28.1169 41.987Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckBlackbg);
export default __webpack_public_path__ + "static/media/check-blackbg.605725802a4681f951df5bcb26bc7185.svg";
export { ForwardRef as ReactComponent };